import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '@examsoft/es-login';
import { environment } from '@environments/environment'

@Injectable({
  providedIn: 'root'
})
export class EulaService {
  agreementServiceURL: string =  `${environment.urls.pltApiUrl}/agreements-ui`;


  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {

  }

   hasAcceptedLatest(esId) {
    const requestOptions = {
      headers: new HttpHeaders({
        Authorization: this.authService.getJwt(),
        'Content-Type': 'application/json',
        'x-es-txn-id': esId
      })
    };
    return this.http.get(
      `${this.agreementServiceURL}/${esId}?app=examnow&agreement=examnow_terms_and_conditions.html`,
      requestOptions
    )
  }
  acceptLatestAgreement(esId) {
    const requestOptions = {
      headers: new HttpHeaders({
        Authorization: this.authService.getJwt(),
        'Content-Type': 'application/json',
        'x-es-txn-id': esId
      })
    };
    return this.http.post(
      `${this.agreementServiceURL}/${esId}`,
      {
        app: 'examnow',
        agreement: 'examnow_terms_and_conditions.html',
        agreementAccepted: true,
        agreementAcceptedTimestamp: Date.now()
      },
      requestOptions
    )
  }
}
